import type { GetClassStudentAnswersQuery } from '../present/activity-answers.graphql.generated';
import { Student } from '../classroom/classroom.constants';
import type { Pluck } from 'lib/gql/pluck';

/**
 * Creates a Set of student IDs that have answers
 */
export function getStudentIdsWithAnswersSet(
  answers:
    | Pluck<GetClassStudentAnswersQuery, 'getClassStudentsAnswers'>[]
    | undefined
): Set<number> {
  return new Set(
    (answers?.map(answer => answer.studentId).filter(Boolean) as number[]) || []
  );
}

/**
 * Splits students into those with answers and those without answers
 */
export function getSplitStudentsByAnswers(
  students: Student[],
  studentIdsWithAnswersSet: Set<number>
): {
  studentsWithAnswers: Student[];
  studentsWithoutAnswers: Set<number>;
} {
  const withAnswers: Student[] = [];
  const withoutAnswers: Set<number> = new Set();

  students.forEach(s =>
    studentIdsWithAnswersSet.has(s.id)
      ? withAnswers.push(s)
      : withoutAnswers.add(s.id)
  );

  return {
    studentsWithAnswers: withAnswers,
    studentsWithoutAnswers: withoutAnswers,
  };
}

/**
 * Returns boolean if no students are selected
 */
export function getNoStudentsSelected(selectedStudents: Student[]): boolean {
  return selectedStudents.length === 0;
}

/**
 * Returns boolean if there are no students with answers
 */
export function getNoStudentsWithAnswers(
  studentsWithAnswers: Student[]
): boolean {
  return studentsWithAnswers.length === 0;
}
